import { yupResolver } from '@hookform/resolvers/yup';
import { Resolver } from 'react-hook-form';
import { CreateUserResourceT, OneUserResourceT } from 'shared/api/types/user-resources';
import * as Yup from 'yup';
import initDefaultSchema from '../yupConfig';

initDefaultSchema();

// Create UserResource
export type CreateUserResourceFormT = CreateUserResourceT['request'];
export const getCreateUserResourceValues = (): CreateUserResourceFormT => ({
  userId: null,
  resourceId: null,
  resourceType: '',
});
const createUserResourceSchema: Yup.ObjectSchema<CreateUserResourceFormT> = Yup.object({
  userId: Yup.string().required(),
  resourceId: Yup.string().required(),
  resourceType: Yup.string(),
});
export const createUserResourceResolver = yupResolver(createUserResourceSchema) as Resolver<CreateUserResourceFormT>;

// Update UserResource
export type UpdateUserResourceFormT = CreateUserResourceFormT;
export const getUpdateUserResourceValues = (values?: OneUserResourceT['response']): UpdateUserResourceFormT => ({
  userId: values?.user.id,
  resourceId: values?.resource.id,
  resourceType: values?.resource.type,
});
const updateUserResourceSchema: Yup.ObjectSchema<UpdateUserResourceFormT> = Yup.object({
  userId: Yup.string().required(),
  resourceId: Yup.string().required(),
  resourceType: Yup.string(),
});
export const updateUserResourceResolver = yupResolver(updateUserResourceSchema) as Resolver<UpdateUserResourceFormT>;
